import { render } from "./HeaderTest.vue?vue&type=template&id=248b9358&scoped=true"
import script from "./HeaderTest.vue?vue&type=script&lang=js"
export * from "./HeaderTest.vue?vue&type=script&lang=js"

import "./HeaderTest.vue?vue&type=style&index=0&id=248b9358&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248b9358"]])

export default __exports__